export enum AppointmentActionTypes {
  API_RESPONSE_SUCCESS = '@@appointments/API_RESPONSE_SUCCESS',
  API_RESPONSE_ERROR = '@@appointments/API_RESPONSE_ERROR',

  SET_LOADING_APPOINTMENTS = '@@appointments/SET_LOADING',
  RESET = '@@appointments/RESET',
  APPOINTMENTS = '@@appointments/APPOINTMENTS',

}
